import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const COUNTRIES_COUNTRY_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/countries',
        iconClass: 'fas fa-file-alt',
        name: 'AdministrationService::Menu:Countries',
        parentName: '::Menu:Settings',
        layout: eLayoutType.application,
        requiredPolicy: 'AdministrationService.Countries',
      },
    ]);
  };
}
